import React, { useState } from "react";
import moment from "moment";
import "moment/locale/bg";
import { useInput, ValidationError } from "react-admin";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

// Clearing only one section (e.g. the hours) makes the picker emit an invalid date instead of null,
// which handleChange stores as "YYYY-MM-DDTInvalid date" - a non-empty string that required() lets through.
const isValidTime = value =>
  !value || moment(value, moment.ISO_8601, true).isValid() ? undefined : "Моля въведете валиден час!";

const CustomTimeInput = props => {
  const { onChange, noDate, onBlur, required, validate, readOnly, defaultDateValue, disabled, ...rest } = props;

  const {
    field,
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
    isRequired,
  } = useInput({
    onChange,
    onBlur,
    readOnly,
    disabled,
    ...props,
    // always appended - otherwise a partially cleared time passes required() (see isValidTime)
    validate: [].concat(validate ?? [], isValidTime),
  });
  const [isFieldInvalid] = useState(invalid);

  const handleChange = time => {
    if (time) {
      const changedValue = `${moment(defaultDateValue).format("YYYY-MM-DD")}T${time.format("HH:mm:ss")}`;
      field.onChange(changedValue);
    } else {
      field.onChange(null);
    }
  };

  const value = field?.value ? moment(field.value) : null;

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      dateLibInstance={moment.utc}
      adapterLocale="bg"
    >
      <TimePicker
        {...field}
        label={props.label}
        value={value}
        onChange={handleChange}
        error={isFieldInvalid || ((isTouched || isSubmitted) && invalid)} // Highlight error if touched or submitted
        helperText={(isTouched || isSubmitted) && isFieldInvalid ? error : ""}
        required={required}
        validate={validate}
        readOnly={readOnly}
        disabled={readOnly}
        slotProps={{
          actionBar: {
            actions: ["clear"],
          },
          textField: {
            // isRequired is true when validate contains required() - shows the "*" like other react-admin inputs
            required: Boolean(required) || isRequired,
            helperText: invalid && error ? <ValidationError error={error?.message || error} /> : "",
            error: invalid,
            InputProps: {
              style: {
                color: invalid ? "#9D1B53;" : "",
              },
              readOnly: readOnly,
              disabled: disabled || readOnly,
            },
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default CustomTimeInput;
